import { Alert, Button, Descriptions, List, Modal } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { CsvUpdateResponse } from '../../model/csvupadte_request';

type Props = {
  show: boolean;
  response?: CsvUpdateResponse;
  onOk: () => void;
};

export const ConflictModal : React.FC<Props> = ({ show, response, onOk }) => {
  const [open, setOpen] = useState(show);

  useEffect(() => {
    setOpen(show);
  }, [show]);

  const handleOk = useCallback(() => {
    setOpen(false);
    onOk();
  }, [onOk]);

  if (response === undefined) {
    return null;
  }

  const rows = response.rows.filter((row) => row.hasWarning);

  return (
        <Modal
            title={'競合が発生しました'}
            centered
            open={open}
            footer={() => {
              return (
                    <>
                        <Button onClick={() => setOpen(false)}>キャンセル</Button>
                        <Button type={'primary'} onClick={handleOk}>強制的に更新</Button>
                    </>
              );
            }}
            onCancel={() => setOpen(false)}
            width={800}
        >
            <Alert type={'warning'} description={<>以下の行が他のユーザーによって更新されています。<br/>「強制的に更新」ボタンを押下すると競合している箇所も更新します。</>} />
            <List dataSource={rows} renderItem={(item) => {
              return (
                <List.Item>
                    <Descriptions bordered style={{ width: '100%' }}>
                        <Descriptions.Item contentStyle={{ width: '100px' }} label={'ID'}>{item.rowId}</Descriptions.Item>
                        <Descriptions.Item label={'競合箇所'}>
                            {item.columns.filter((c) => c.validationResult === 'warning').map((column) => {
                              return (
                                    <div key={column.key}>
                                        <b>列:</b> {column.name}&nbsp;→&nbsp;<b>値:</b> {column.value} <span style={{ color: 'red' }}>(最新: {column.originalData})</span>
                                    </div>
                              );
                            })}
                        </Descriptions.Item>
                    </Descriptions>
                </List.Item>
              );
            }}/>
        </Modal>
  );
};
